import * as React from "react"
import Layout from "../components/layout"
import { StaticImage } from 'gatsby-plugin-image'
import ColoredLine from "../components/coloredline"
import { Container, Row, Col, Card } from 'react-bootstrap';


const AboutPage = () => {

  return (

    <Layout pageTitle="Über DEROPTIKER zielinski">

      <Container>

        <br></br>
        <br></br>
        <br></br>

        <h2>lang lang ist's her....</h2>
        <p class="text-justify">

          Michael Zielinski begann seine Optikerlaufbahn 1978 als Lehrling, arbeitete in verschiedenen Optikerfirmen,
          bis 1997 der Schritt in die Selbständigkeit stattfand. Mit der Firmengründung stand
          ihm auch seine Frau Ursula bei und einige Monate später wurde auch
          Patrick Soboszek ein fixer Bestandteil der Firma. Seit 2012 ist der
          neue Standort am Simmeringer Platz.

        </p>

        <ColoredLine />


        <h2>unser team</h2>

        <p>

          DER OPTIKER zielinski besteht aus einem 4-köpfigen Team. Neben dem Eigentümer Michael Zielinski und seiner Frau Ursula sind noch 2 Mitarbeiter beschäftigt.
          <br></br>
          Lernen Sie in den nachfolgenden Zeilen unsere Mitarbeiter kennen:
        </p>

        <Row>

          <Col lg={4} md={4} xs={6}>
            <Card className="text-center">
              <StaticImage
                className="d-block w-100"
                alt="michael zielinski - eigentümer"
                src="../images/michael_zielinski.jpeg"
              />
              <Card.Body>
                <Card.Title>michael zielinski - eigentümer</Card.Title>
                <Card.Text>
                  Michael Zielinski ist der Gründer und Eigentümer von DER OPTIKER zielinski. Er ist ausgebildeter Brillen- und Kontaktlinsenmeister.
                </Card.Text>

              </Card.Body>
            </Card>
            <br />
          </Col>


          <Col lg={4} md={4} xs={6}>
            <Card className="text-center">
              <StaticImage
                className="d-block w-100"
                alt="ursula zielinski - organisation"
                src="../images/ursula_zielinski.jpeg"
              />
              <Card.Body>
                <Card.Title>ursula zielinski - organisation</Card.Title>
                <Card.Text>
                  Ursula Zielinski ist für alles rund um die Organisation zuständig. Sie können sie aber auch im Verkauf antreffen.
                </Card.Text>

              </Card.Body>
            </Card>
            <br />
          </Col>

        </Row>

        <Row>

          <Col lg={3} md={3} xs={5}>
            <Card className="text-center">
              <StaticImage
                className="d-block w-100"
                alt="patrick soboszek - geselle"
                src="../images/patrick_soboszek.jpeg"
              />
              <Card.Body>
                <Card.Title>patrick soboszek - geselle</Card.Title>
                <Card.Text>
                  Patrick Soboszek ist jener Mitarbeiter welcher am längsten bei DER OPTIKER beschäftigt ist.
                </Card.Text>

              </Card.Body>
            </Card>
            <br />
          </Col>

          <Col lg={3} md={3} xs={5}>
            <Card className="text-center">
              <StaticImage
                className="d-block w-100"
                alt="phillip caj - geselle "
                src="../images/phillip-caj.jpeg"
              />
              <Card.Body>
                <Card.Title>phillip caj - geselle </Card.Title>
                <Card.Text>
                  <br></br>
                  Seit 1. Juli 2021 verstärkt er unser Team. Foto folgt…..
                </Card.Text>

              </Card.Body>
            </Card>
            <br />
          </Col>

        </Row>

        <ColoredLine />

        <h2>Panoramatour durch DER OPTIKER zielinski</h2>

        <p>
          Sie wollen wissen wie es bei uns aussieht? Sehen Sie sich
          einfach bei uns um, bequem von ihrem Browser aus! Danke an
          <a href="http://www.svenspix.at" title=""> svenspix.at </a> für
          die tollen Aufnahmen. Auf Ihrem Mobilgerät funktionieren sogar
          die Bewegungssensoren. Einfach das Gerät drehen wie wenn Sie bei
          uns im Geschäft stehen würden.
        </p>

        <div className="text-center">
          <a href="http://der-optiker.at/panorama/index.html">
            <StaticImage
              className="w-30"
              src="../images/panorama.jpg"
              alt="Panorama"
              title="Panoramatour durch DER OPTIKER zielinski"
            />
          </a>
        </div>

        <ColoredLine />

        <h2>friends von DER OPTIKER zielinski</h2>

        <p>

          So wie jeder hat auch DER OPTIKER gute Freunde. Von Beschriftungen jeglicher Art bis hinzu griechischen Spezialitäten.
          <br></br>
          Lesen Sie weiter unten mehr über unsere Freunde:
        </p>


        <Row>
          <Col lg={3} md={6} xs={12}>
            <h4>Autosattlerei von Plachen Michael Groiss</h4>
            <p>Danke für die perfekte Arbeit bei unserem Refraktionsstuhl.</p>
            <StaticImage
              className="d-block w-100"
              alt="Logo Autosattlerei Plachen Michael Groiss"
              src="../images/auto-sattlerei-groiss.png"
            />
            <br></br>
            <a href="http://www.auto-sattlerei.at/" target="_blank" rel="noopener noreferrer">
              Autosattlerei Plachen Michael Groiss
            </a>

          </Col>

          <Col lg={3} md={6} xs={12}>
            <h4>Ein Arzt fürs Tauchen und akupunktur</h4>
            <p>Nachdem Tauchen zu einer unserer Leidenschaft gehört, müssen wir dort natürlich auch rundum versorgt werden. Dr.Angel Lopez
              in Simmering ist hier der perfekte Ansprechpartner, wir können ihn und seine Praxis nur empfehlen.</p>
            <StaticImage
              className="d-block w-100"
              alt="Foto von Taucharzt Dr.Angel Lopez"
              src="../images/side_doclopez.png"
            />
            <br></br>
            <a href="http://www.doc-lopez.at/hno/" target="_blank" rel="noopener noreferrer">
              Taucharzt Dr.Angel Lopez
            </a>

          </Col>


          <Col lg={3} md={6} xs={12}>
            <h4>Beschriftung gefällig?</h4>
            <p>
              Es werden Werbeaufschriften, Fassadengestaltungen, Autobeschriftungen, Firmenschilder und das in individuellem
              Design sowie in jeder technischen Ausfertigung, vom Digitaldruck bis zur elektronisch gesteuerten Leuchtschrift angefertigt.
              <br></br>
              <br></br>
              Seit 2018 ist Herr Fichtiger in Fischamend.
              <br></br>
              <br></br>

            </p>
            <StaticImage
              className="d-block w-100"
              alt="Logo Beschriftungen Fa.Fichtinger "
              src="../images/fichtinger.png"
            />
            <br></br>
            <a href="http://www.fichtingerbeschriftungen.at/" target="_blank" rel="noopener noreferrer">
              Beschriftungen Fa.Fichtinger
            </a>

          </Col>

        </Row>


        <ColoredLine />

        <h2>rotes kreuz</h2>

        <p>

          Unsere Tochter Julia war mehrere Jahre ehrenamtlich beim Roten Kreuz beschäftigt.
          Neben ihrem Studium und ihrem Teilzeitjob versuchte sie so oft wie möglich Dienst für das Rote Kreuz
          zu leisten.
          <br></br>
          Dadurch ist es nicht weit hergeholt, dass wir nicht nur sie sondern auch ihre Dienstelle(n)
          unterstützten. Die wohl auffälligste Unterstützung war die Einweihung eines Rettungsautos mit
          den Namen "sedaju". Der Name setzt sich aus den Anfangsbuchstaben unserer Kinder zusammen - Sebastian, Daniel und Julia.
          <br></br>
          Mittlerweile ist sie Notfallsanitärerin bei der Wiener Rettung.

        </p>

        <br></br>


        <Row>
          <Col>
            <StaticImage
              alt="Rotes Kreuz Spende DER OPTIKER Zielinski"
              src="../images/roteskreuz2.png"
            />
          </Col>

          <Col>
            <StaticImage
              alt="Rotes Kreuz Spende DER OPTIKER Zielinski"
              src="../images/roteskreuz3.png"
            />
          </Col>
        </Row>

      </Container>

    </Layout>

  )

}

export default AboutPage